import { Action } from '@ngrx/store';
import {NodesFilter} from '../node.model';

export enum NodeFilterActionTypes {
  LoadNodeFilters = '[NodeFilter] Load NodeFilters'
}

export class LoadNodeFilters implements Action {
  readonly type = NodeFilterActionTypes.LoadNodeFilters;
  constructor(public payload: NodesFilter) {}
}


export type NodeFilterActions = LoadNodeFilters;
